<template>
  <div v-if="doneLoading" class="api-error-message">
    <p>
      Currently {{ apiName }} is unavailable.
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      apiName: {
        type: String,
        default: 'this graphs API endpoint'
      }
    },
    computed: {
      doneLoading () {
        return !this.$store.getters.loading
      }
    }
  }
</script>

<style lang="scss">
  .api-error-message {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: rem(21);
    text-transform: uppercase;
    color: color(grays, light);

    p {
      padding: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// ApiErrorMessage.vue?2e5f5668